<template>
  <div>
    <el-button
      round
      v-bind="$attrs"
      v-on="$listeners"
      class="w-full text-white border-none bg-primary"
    >
      <slot />
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'SButton',
  inheritAttrs: false
}
</script>

<style scoped>
>>> .el-button.is-round {
  height: 48px;
  border-radius: 40px;
}
>>> .el-button:focus,
.el-button:hover {
  color: white;
  opacity: 0.8;
  border-color: #c7c8d2;
  background-color: var(--color-primary);
}
</style>
